import React from 'react'
import { ReactComponent } from './UnPinIcon.svg'
import { MergeReactElementProps } from '../types'

interface UnPinIconProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', UnPinIconProps>

export const UnPinIcon = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = '#9a9a9a' } = props
    return <ReactComponent stroke={color} ref={ref} {...props} />
  }
)
